import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loading = false;
  currentYear = new Date().getFullYear();

  isXeroAuthEnabled = false;

  formData: {
    email: string;
    password: string;
  } = { email: null, password: null };

  constructor(
    private toastr: NbToastrService,
    private router: Router,
    private featureFlag: FeatureFlagService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.featureFlag.isEnabled('xeroAuthEnabled').then((isEnabled) => {
      this.isXeroAuthEnabled = isEnabled;
    });
  }

  async onSubmit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    this.loading = true;
    try {
      await this.userService.signIn(this.formData.email, this.formData.password);
      this.router.navigate(['/home/convert']);
    } catch (error) {
      this.toastr.warning(error.message, 'Sign In Failed');
      console.error(error);
    }
    this.loading = false;
  }

  loginWithXero() {
    this.router.navigate(['/auth/xero-signin']);
  }
}
